import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const HomeIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={className}
        data-testid={testId}
        fill='none'
        height='25'
        viewBox='0 0 22 25'
        width='22'
        xmlns='http://www.w3.org/2000/svg'>
        <path
            clipRule='evenodd'
            d='M9.26206 1.15949C10.2587 0.279991 11.7664 0.279991 12.763 1.16057L20.6269 8.11245C21.1871 8.60946 21.5043 9.31824 21.5 10.0638L21.4146 21.9242C21.4037 23.3525 20.2287 24.5021 18.7845 24.5L3.12241 24.4762C1.67392 24.4741 0.5 23.3136 0.5 21.8831V10.0499C0.5 9.31303 0.819469 8.60966 1.37742 8.11697L9.26206 1.15949ZM10.4283 2.44849L2.54264 9.4066C2.35665 9.56867 2.25162 9.80313 2.25162 10.0495V21.8827C2.25162 22.3602 2.64111 22.747 3.12465 22.747L18.7879 22.7708C19.2682 22.7708 19.6599 22.3883 19.6631 21.9118L19.7496 10.0494C19.7507 9.80196 19.6456 9.56641 19.4575 9.40001L11.5958 2.44928C11.2632 2.15539 10.7611 2.15539 10.4285 2.4482L10.4283 2.44849ZM6.6408 21.0443C6.15833 21.0443 5.76667 20.6564 5.76667 20.1799C5.76667 19.7035 6.15833 19.3156 6.6408 19.3156H15.38C15.8625 19.3156 16.2552 19.7035 16.2552 20.1799C16.2552 20.6564 15.8625 21.0443 15.38 21.0443H6.6408Z'
            fill='currentColor'
            fillRule='evenodd'
        />
    </svg>
);

export default HomeIcon;
